export const DEVICE_MAP = {
    xs: "xsmall",
    s: "small",
    m: "medium",
    l: "large",
    xl: "xlarge",
};
